import React from 'react';
import { Slot } from 'expo-router';
import { healthProfileKey } from '../../../constants/routeKeys';
import { title } from '../../../components/Root/title';

// Backward compatibility alias

export default function Layout() {
  return (
    <Slot
      initialRouteName={healthProfileKey}
      screenOptions={({ route }) => {
        return {
          headerShown: false,
          title: title(route.name),
        };
      }}
    />
  );
}
